<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card sq-card">
          <div class="card-header card-header-squirrel" style="height: 63px">
            <h4 class="card-title">{{this.translate.data['YOURPROJECTS'] | translate}}</h4>
            <!-- to force same hight as other lists -->
            <!-- <button matTooltip="" mat-raised-button type="submit" class="btn btn-squirrel pull-right"  [hidden]="false">
              <mat-icon></mat-icon>
            </button> -->
          </div>
          <div class="card-body">
            <div class="user-projects-table">
              <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                  Squirrel's API rate limit has been reached. It will be reset in one minute.
                </div>
              </div>
              <ag-grid-angular class="ag-theme-balham"
                style="height: 100%; width: 100%; padding: 5px;"
                [overlayLoadingTemplate]="overlayLoadingTemplate"
                [gridOptions]="gridOptions"
                (gridReady)="onGridReady($event)" 
                (rowClicked)="onRowClicked($event)"
                (rowSelected)="onRowSelected($event)" 
                [frameworkComponents]="frameworkComponents"               
                [rowData]="rowData">
              </ag-grid-angular>
            </div>            
          </div>
        </div>
      </div>

      <!-- <div class="col-md-8">
        <div class="card sq-card">
          <div class="card-body">
            <div class="sq-map">
              <squirrel-site-map></squirrel-site-map>
            </div>            
          </div>
        </div>
      </div>       -->

    </div>
  </div>
</div>